module.exports = {"helmetTitle":"Veloe - Cancelar conta","title":"Processo de cancelamento","infoSubtitle":"Você quer realmente voltar a contar o troco do pedágio?","text":"Fazendo o cancelamento, seus planos vão ser suspensos e você não vai mais ter acesso livre aos locais conveniados. E ainda vai ter que tomar cuidado para não perder nenhum ticket de estacionamento.","optionsSubtitle":"Por que você quer cancelar sua conta?"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/CancelAccount/data.json
// module id = 1772
// module chunks = 0